import { render } from "./WealthCalculator.vue?vue&type=template&id=e77e54f4"
import script from "./WealthCalculator.vue?vue&type=script&lang=js"
export * from "./WealthCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__